import { render, staticRenderFns } from "./DropdownMenu.vue?vue&type=template&id=4c94beb4&scoped=true"
import script from "./DropdownMenu.vue?vue&type=script&lang=js"
export * from "./DropdownMenu.vue?vue&type=script&lang=js"
import style0 from "./DropdownMenu.vue?vue&type=style&index=0&id=4c94beb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c94beb4",
  null
  
)

export default component.exports